module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 118.cbd70d02.png";